var $117b536bfb1ae554$exports = {};
$117b536bfb1ae554$exports = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{7D22}`
};


export {$117b536bfb1ae554$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
